import React, { Component } from "react";
import Header from "./Header";
import Approach from "./Approach";
import Services from "./Services";
import Innovation from "./Innovation";
import Platform from "./Platform";
import Clients from "./Clients";
import Collaboration from "./Collaboration";
import ExecutiveTeam from "./ExecutiveTeam";
import WorkPlay from "./WorkPlay";
import Jobs from "./Jobs";
import Team from "./Team";
import MailingListForm from "./MailingListForm";
import VideoLanding from "./VideoLanding";
import Footer from "./Footer";


export default class Home extends Component {
  render() {
    return (
      <div>
        <Header />
        <VideoLanding/>
        <Services />
        <Approach />
        <Innovation/>
        <Platform/>
        <Clients/>
        <Collaboration/>
        <ExecutiveTeam/>
        <WorkPlay/>
        <Jobs/>
        <Team />
        <MailingListForm />
        <Footer />
      </div>
    );
  }
}